export default __webpack_public_path__ + "static/constitution-2020-03-8aabf9f609243aba7907b27092d48586.pdf";